module.exports = __webpack_public_path__ + "fonts/iconfont.94a792a8.woff2";